import { Component, Prop, h, Host, Watch, State, Event, EventEmitter } from '@stencil/core';

@Component({
  tag: 'dda-teamsection-card',
  styleUrls: [],
  shadow: false,
})
export class DdaImageCard {
  @Prop() image_src: string;
  @Prop() header_text: string;
  @Prop() profession: string;
  @Prop() body_text: string;
  @Prop() body_text_two: string;
  @Prop() sajin: string;
  @Prop() custom_class?: string = '';
  @Prop() component_mode?: string;
  @Prop() card_type: 'variant-one' | 'variant-two' | 'variant-three' | 'variant-four' | 'variant-five' | 'variant-six' | 'variant-seven' | 'variant-eight' | 'full' = 'variant-one';
  @Event() navigatorClick?: EventEmitter<string>;
  @Prop() useNavigator: 'true' | 'false' = 'false';
  @Prop() social_icons: any = [];
  @State() parsedSocialIcons: {
    SocialLink: string;
    SocialIconText?: string;
    SocialLinkTitle?: string;
    SocialIconSrc?: string;
    SocialIconAlt?: string;
  }[] = [];

  @Watch('social_icons')
  parseSocialIcons(newVal: any) {
    if (typeof newVal === 'string') {
      try {
        this.parsedSocialIcons = JSON.parse(newVal);
      } catch (e) {
        this.parsedSocialIcons = [];
        console.warn('Failed to parse social_icons JSON string', e);
      }
    } else if (Array.isArray(newVal)) {
      this.parsedSocialIcons = newVal;
    } else {
      this.parsedSocialIcons = [];
    }
  }

  componentWillLoad() {
    this.parseSocialIcons(this.social_icons);
  }

  private renderCards() {
    switch (this.card_type) {
      case 'variant-one':
        return (
          // <div class={`${this.component_mode}`}>
          //   {this.image_src && <img src={this.image_src} alt={this.header_text || 'Team member'} />}
          //   {this.header_text && (
          //     <div class="dda-p-3 teamsection-type-one-body">
          //       <div class="teamsection-type-one-content">
          //         <h5 class="h5 Regular">{this.header_text}</h5>
          //         {this.body_text && (
          //           <p class="body-text body Regular">{this.body_text}</p>
          //         )}
          //       </div>
          //     </div>
          //   )}
          // </div>
          <div class={`${this.component_mode}`} role="group" aria-label={this.header_text || 'Team member card'}>
            {this.image_src && (
              <img src={this.image_src} alt={this.header_text ? `${this.header_text}'s profile picture` : 'Team member profile picture'} class="team-member-image" />
            )}

            {this.header_text && (
              <div class="dda-p-3 teamsection-type-one-body">
                <div class="teamsection-type-one-content">
                  <h5 class="h5 Regular">{this.header_text}</h5>

                  {this.body_text && <p class="body-text body Regular">{this.body_text}</p>}
                </div>
              </div>
            )}
          </div>
        );

      case 'variant-two':
        return (
          <div class={`${this.component_mode}`} role="group" aria-label={this.header_text || 'Team member card'}>
            {this.image_src && <img src={this.image_src} alt={this.header_text ? `${this.header_text}'s profile picture` : 'Team member profile picture'} />}
            {this.header_text && (
              <div class="dda-pt-3">
                <h5 class="h5 Regular">{this.header_text}</h5>
                {this.body_text && <p class="body-text body Regular">{this.body_text}</p>}
              </div>
            )}
          </div>
        );

      case 'variant-three':
        return (
          <div class={`${this.component_mode}`} role="group" aria-label={this.header_text || 'Team member card'}>
            {this.image_src && <img src={this.image_src} alt={this.header_text ? `${this.header_text}'s profile picture` : 'Team member profile picture'} />}
            {this.header_text && (
              <div class="dda-pt-3 dda-mb-3">
                <h5 class="h5 Regular">{this.header_text}</h5>
                {this.body_text && <p class="body-text body Regular">{this.body_text}</p>}
              </div>
            )}

            {this.parsedSocialIcons?.length > 0 && (
              <ul class="dda-social-icons-card" aria-label={`${this.header_text} Social media links`}>
                {this.parsedSocialIcons.map((item, index) => (
                  <li key={index}>
                    <a
                      // href={item.SocialLink}
                      href={this.useNavigator == 'true' ? 'javascript:void(0)' : item.SocialLink}
                      onClick={() => (this.useNavigator == 'true' ? this.navigatorClick.emit(item.SocialLink) : '')}
                      title={item.SocialLinkTitle || item.SocialIconText || 'Social media link'}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label={item.SocialIconText || item.SocialLinkTitle || 'Social media link'}
                    >
                      {item.SocialIconSrc && <img src={item.SocialIconSrc} alt={item.SocialIconAlt || item.SocialIconText || ''} class="social-icon" />}
                      {/* Screen-reader-only fallback text */}
                      {item.SocialIconText && <span class="visually-hidden">{item.SocialIconText}</span>}
                    </a>
                  </li>
                ))}
              </ul>
            )}
          </div>
        );

      case 'variant-four':
        return (
          <div class={`${this.component_mode}`} role="group" aria-label={`Team member card${this.header_text ? ` for ${this.header_text}` : ''}`}>
            <div class="dda-row no-gutters">
              <div class="dda-col-sm-4 dda-p-0">
                <img src={this.image_src} alt={this.header_text ? `${this.header_text}'s profile photo` : 'Team member profile photo'} />
              </div>
              <div class="dda-col-sm-8">
                <div class="dda-h-100 dda-d-flex dda-align-items-center">
                  <div class="dda-teamsection-variant-four-body dda-py-4 dda-d-flex dda-flex-column dda-gap-4">
                    {/* Name and Profession */}
                    <div>
                      {this.header_text && (
                        <h5 class="h5 Regular" aria-label="Team member name">
                          {this.header_text}
                        </h5>
                      )}
                      {this.profession && (
                        <p class="body Regular dda-color-primary" aria-label="Profession">
                          {this.profession}
                        </p>
                      )}
                    </div>
                    {/* Description */}
                    {this.body_text && <p class="body-text body Regular">{this.body_text}</p>}
                    {/* Social Media Links */}
                    {this.parsedSocialIcons?.length > 0 && (
                      <ul class="dda-social-icons-card" aria-label={`${this.header_text} Social media links`}>
                        {this.parsedSocialIcons.map((item, index) => (
                          <li key={index}>
                            <a
                              // href={item.SocialLink}
                              href={this.useNavigator == 'true' ? 'javascript:void(0)' : item.SocialLink}
                              onClick={() => (this.useNavigator == 'true' ? this.navigatorClick.emit(item.SocialLink) : '')}
                              title={item.SocialLinkTitle || item.SocialIconText || 'Social media link'}
                              aria-label={item.SocialIconText || item.SocialLinkTitle || 'Social media link'}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {item.SocialIconSrc && <img src={item.SocialIconSrc} alt={item.SocialIconAlt || item.SocialIconText || 'Social media icon'} />}
                              {item.SocialIconText && <span class="visually-hidden">{item.SocialIconText}</span>}
                            </a>
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        );

      case 'variant-five':
        return (
          <div class={`${this.component_mode}`} role="group" aria-label={`Team member card${this.header_text ? ` for ${this.header_text}` : ''}`}>
            {this.image_src && <img src={this.image_src} alt={this.header_text ? `${this.header_text}'s profile photo` : 'Team member profile photo'} />}

            {this.header_text && (
              <div class="dda-p-3 teamsection-type-five-body">
                <div>
                  <h5 class="h5 Regular" aria-label="Team member name">
                    {this.header_text}
                  </h5>
                  {this.body_text && <p class="body-text body Regular">{this.body_text}</p>}
                </div>
              </div>
            )}
          </div>
        );

      case 'variant-six':
        return (
          <div class={`dda-teamsection-variant-six ${this.component_mode}`} role="group" aria-label={`Team member card${this.header_text ? ` for ${this.header_text}` : ''}`}>
            {this.image_src && <img class="dda-rounded-circle" src={this.image_src} alt={this.header_text ? `${this.header_text}'s profile photo` : 'Team member profile photo'} />}

            {this.header_text && (
              <div class="dda-col">
                <h5 class="h5 Regular" aria-label="Team member name">
                  {this.header_text}
                </h5>
                {this.body_text && <p class="body-text body Regular">{this.body_text}</p>}
              </div>
            )}
          </div>
        );

      case 'variant-seven':
        return (
          <div class={`dda-teamsection-variant-seven ${this.component_mode}`} role="group" aria-label={`Team member card${this.header_text ? ` for ${this.header_text}` : ''}`}>
            {this.image_src && <img class="" src={this.image_src} alt={this.header_text ? `${this.header_text}'s profile photo` : 'Team member profile photo'} />}
            {this.header_text && (
              <div>
                <h5 class="h5 Regular" aria-label="Team member name">
                  {this.header_text}
                </h5>
                {this.body_text && <p class="body-text body Regular">{this.body_text}</p>}
              </div>
            )}
          </div>
        );

      case 'variant-eight':
        return (
          <div class={`dda-teamsection-variant-eight ${this.component_mode}`} role="group" aria-label={`Team member card${this.header_text ? ` for ${this.header_text}` : ''}`}>
            {this.image_src && <img class="" src={this.image_src} alt={this.header_text ? `${this.header_text}'s profile photo` : 'Team member profile photo'} />}
            <div>
              {this.header_text && (
                <h5 class="h5 Regular" aria-label="Team member name">
                  {this.header_text}
                </h5>
              )}
              {this.body_text && <p class="body-text body Regular">{this.body_text}</p>}
            </div>
            {this.body_text_two && <p class="body-text body Regular">{this.body_text_two}</p>}
          </div>
        );

      // Add 'full' case if needed later.
    }
  }

  render() {
    const cardClass = ['dda-teamsection-card', this.custom_class].filter(Boolean).join(' ');

    return (
      <Host>
        <div class={cardClass}>{this.renderCards()}</div>
      </Host>
    );
  }
}
